import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainLayout from './components/MainLayout';
import Login from './pages/Login';
import Customer from './pages/Customer';
import SupplierLogin from './pages/SupplierLogin';
import CertificateView from './pages/CertificateView';
import CertificateUpload from './pages/CertificateUpload';
import SupplierPerformance from './pages/SupplierPerformance';
import AdminMainLayout from './components/AdminMainLayout';
import SupplierControl from './pages/SupplierControl';
import AdminMain from './pages/AdminMain';
import PrivateRoute from './PrivateRoute';
import AuthProvider from './AuthProvider';
import ProtectedRoute from './ProtectedRoute';
import SupplierPage from './pages/SupplierPage';
import RoleAssignment from './pages/RoleAssignment';
import EditProfile from './pages/EditProfile';
import SupplierContacts from './pages/SupplierContacts';
import ForgotPassword from "./pages/ForgotPassword";
import VerifyResetCode from "./pages/VerifyResetCode";
import ResetPassword from "./pages/ResetPassword";
import Info from './pages/Info';
import SupplierPerformanceDataEntry from './pages/SupplierPerformanceDataEntry';
import SupplierPerformanceDataList from './pages/SupplierPerformanceDataList';
import ContactTypeManagement from './pages/ContactTypeManagement';
import './i18n';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* ✅ Public Routes */}
          <Route path="/" element={<Login />} />
          <Route path='/info' element={<Info />} />
          <Route path="supplier-login" element={<SupplierLogin />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/verify-reset-code" element={<VerifyResetCode />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          {/* ✅ Supplier Routes */}
          <Route 
            path="/main" 
            element={
              <PrivateRoute>
                <ProtectedRoute requiredRole="Supplier">
                  <MainLayout />
                </ProtectedRoute>
              </PrivateRoute>
            }
          >
            <Route index element={<Customer />} />
            <Route path="customer" element={<Customer />} />
            <Route path="certificate-upload" element={<CertificateUpload />} />
            <Route path="supplier-performance" element={<SupplierPerformance />} />
            <Route path="edit-profile" element={<EditProfile />} />
            <Route path='supplier-contacts' element={<SupplierContacts />} />
          </Route>

          {/* ✅ Admin Routes (SuperAdmin, Admin, Viewer) */}
          <Route 
            path="/admin-dashboard" 
            element={
              <PrivateRoute>
                <ProtectedRoute allowedRoles={["SuperAdmin", "Admin", "Viewer"]}>
                  <AdminMainLayout />
                </ProtectedRoute>
              </PrivateRoute>
            }
          >
            <Route index element={<AdminMain />} />
            <Route path="certificate-view" element={<CertificateView />} />
            <Route path="supplier-control" element={<SupplierControl />} />
            <Route path="supplier-view-page" element={<SupplierPage />} />
            
            {/* ✅ Sadece SuperAdmin */}
            <Route 
              path="role-assignment" 
              element={
                <ProtectedRoute requiredRole="SuperAdmin">
                  <RoleAssignment />
                </ProtectedRoute>
              } 
            />
            
            <Route path="performance-data-entry" element={<SupplierPerformanceDataEntry />} />
            <Route path="performance-data-list" element={<SupplierPerformanceDataList />} />

            <Route
              path="contact-type-management"
              element={
                <ProtectedRoute requiredRole="SuperAdmin">
                  <ContactTypeManagement />
                </ProtectedRoute>
              }
            />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
